import React, { useState, useRef, useEffect } from 'react';
import JqxTree from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxtree';
import { useGetDocumentTeachStructure } from '../../hooks/services/sDocumentTeach/useOfDocumentTeach';
import { base64ToArrayBuffer, base64ToBlob, isNullUndefinedOrEmpty, saveByteArray } from '../../common/Helpers';
import { getDocumentTeachDownload, getDocumentTeachFiles } from '../../services/sDocumentTeach/documentTeach.service';
import { Card, Col, Row, Table } from 'react-bootstrap';
import MessageBox from '../../components/Common/Message/MessageBox';
import { t } from 'i18next';
import { __DocumentTeachType, enum__DOCUMENT_TEACH_TYPE } from '../../common/Dictionaries';
import { DefaultButton, Dialog, DialogContent, DialogFooter, DialogType, Icon, IconButton, SpinnerSize } from '@fluentui/react';
import Loading from '../../components/Templates/Site/Loading';
import { useBoolean } from '@fluentui/react-hooks';
import SidePanelView from './SidePanelView';

const DocumentTeach = () => {
    const myTree = useRef(null);
    const [source, setSource] = useState(null);
    const [selectedPathDocuments, setSelectedPathDocuments] = useState(null);
    const [previewBase64Document, setPreviewBase64Document] = useState(null);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [isPanelViewOpen, setIsPanelViewOpen] = useState(false);

    const obj_TD_Style = {
        paddingBottom: "2px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "left",
        marginLeft: "4px",
        marginRight: "2px",
        lineHeight: "48px",
        backgroundColor: "#fafafa",
        color: "#000000e0",
        fontWeight: "normal",
        fontSize: "14px",
        height: "25px",
        maxHeight: "25px",
        minHeight: "25px",
    }

    const [downloadInProgress, setDownloadInProgress] = useState(false);
    
    useGetDocumentTeachStructure(source, setSource)

    const handleSelect = (event) => {
        const selectedItem = event.args.element;
        const fullPath = getNodePath(selectedItem);
        
        getDocumentTeachFiles(fullPath).then((response) => {
            if (response.data.succeeded) {
                setSelectedPathDocuments(response.data.data);
            }
            else {
                setSelectedPathDocuments([]);
                //setShowMessage(true)
                //setSuccessful(false);
                //setMessageType("error");
                //setMessage(t('data-lang-msg-operationerror'))
            }
        }).catch(() => {
            setSelectedPathDocuments([]);
            //setShowMessage(true)
            //setSuccessful(false);
            //setMessageType("error");
            //setMessage(t('data-lang-msg-operationerror'))
        });
    };

    const getNodePath = (element) => {
        let path = "";
        while (element) {
            const label = element.getElementsByClassName("jqx-tree-item")[0]?.innerText;
            if (label) {
                path = `/${label.trim()}${path}`;
            }
            element = element.parentElement.closest('li');
        }
        return path;
    };

    const getDocumentType = (type) => {
        let objDocumentTeachType = __DocumentTeachType.find(x => x.extension === type);

        if (isNullUndefinedOrEmpty(objDocumentTeachType)) {
            objDocumentTeachType = __DocumentTeachType[enum__DOCUMENT_TEACH_TYPE.OTHER];
        }

        return objDocumentTeachType;
    }

    const handlerDownloadFile = (document) => {
        setDownloadInProgress(true);
        getDocumentTeachDownload([document.url]).then((response) => {
            saveByteArray(`${document.name}${document.extension}`, base64ToArrayBuffer(response.data.data));
            setDownloadInProgress(false);
        }).catch(() => {
            //setShowMessage(true)
            //setSuccessful(false);
            //setMessageType("error");
            //setMessage(t('data-lang-msg-operationerror'))
            setDownloadInProgress(false)
        });
    }

    const handlerPreviewFile = (document) => {
        setDownloadInProgress(true);
        getDocumentTeachDownload([document.url]).then((response) => {
            //saveByteArray(`${document.name}${document.extension}`, base64ToArrayBuffer(response.data.data));
            setPreviewBase64Document(base64ToBlob(response.data.data, "application/pdf"))
            setIsPanelViewOpen(true);
            setDownloadInProgress(false);
        }).catch(() => {
            //setShowMessage(true)
            //setSuccessful(false);
            //setMessageType("error");
            //setMessage(t('data-lang-msg-operationerror'))
            setDownloadInProgress(false)
        });
    }

    useEffect(() => {
        if (myTree.current) {
            myTree.current.focus();
        }
    }, []);

    return (source &&
        <Card>
            <Card.Header>
                <Card.Title className="d-flex justify-content-between">
                    <h4><b>{t('data-lang-boxname-documentteach')}</b></h4>
                </Card.Title>
            </Card.Header>
            <Card.Footer>
                <div className='float-end d-flex'>
                    
                </div>
            </Card.Footer>
            <Card.Footer>
                <MessageBox
                    inputParam_Message={ messageConfig.message }
                    inputParam_Display={ messageConfig.showMessage }
                    inputParam_MessageType={ messageConfig.messageType }
                    inputParam_SetterMessage={ setMessageConfig }
                />
            </Card.Footer>
            <Card.Body style={{width: "100%"}}>
                <Row style={{height: "100%"}} className="align-items-center">
                    <Col className='col-auto ms-auto'>
                        <JqxTree
                            ref={myTree}
                            style={{ tabindex: 1, float: 'left' }}
                            width={250}
                            height={350}
                            source={source}
                            onSelect={handleSelect}
                        />
                    </Col>
                    <Col className='mb-auto'>
                        <Table>
                            <thead>
                                <tr style={{ backgroundColor: '#0F437E', color: 'white', fontWeight: 'bold' }}>
                                    <td style={obj_TD_Style} className='px-1 border-end w-5'>{t('data-lang-lbl-type')}</td>
                                    <td style={obj_TD_Style} className='px-1 border-end w-45'>{t('data-lang-lbl-name')}</td>
                                    <td style={obj_TD_Style} className='px-1 border-end w-45'>{t('data-lang-lbl-folder')}</td>
                                    <td style={obj_TD_Style} className='px-1 border-end w-5'>{t('data-lang-btn-download')}</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    !isNullUndefinedOrEmpty(selectedPathDocuments) &&
                                    selectedPathDocuments.map((document, index) => 
                                        <tr key={index}>
                                            <td className='text-center'><Icon title={getDocumentType(document.extension).text} iconName={getDocumentType(document.extension).icon} /></td>
                                            <td>{document.name}</td>
                                            <td>{document.url.slice(0, document.url.lastIndexOf("/"))}</td>
                                            <td className='text-center'>
                                                {
                                                    downloadInProgress &&
                                                        <Loading
                                                            inputParam_ShowLoading={true}
                                                            inputParam_ShowText={false}
                                                            inputParam_Width={'25px'}
                                                            inputParam_Height={'25px'}
                                                            inputParam_Left={""}
                                                            inputParam_Style={{marginTop: 0}}
                                                            inputParam_ColClassName={"me-2"}
                                                            inputParam_MarginLeft={"auto"}
                                                            inputParam_SpinnerSize={SpinnerSize.medium} />
                                                }
                                                <div className='d-flex'>
                                                    {
                                                        !downloadInProgress &&
                                                        <IconButton title={t('data-lang-btn-download')} iconProps={{iconName: 'Download'}} text={t('data-lang-btn-download')} onClick={() => handlerDownloadFile(document)} />
                                                    }
                                                    {
                                                        document.urlShared.startsWith('User/FAQ') && document.extension === '.pdf' && false &&
                                                        <>
                                                            {
                                                                !downloadInProgress && 
                                                                <IconButton title={t('data-lang-btn-preview')} iconProps={{iconName: 'Preview'}} text={t('data-lang-btn-preview')} onClick={() => handlerPreviewFile(document)} />
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                                {
                                    (isNullUndefinedOrEmpty(selectedPathDocuments) || selectedPathDocuments.length === 0) &&
                                    <tr className='text-center'>
                                        <td colSpan={4}>{t('data-lang-lbl-selectfolder')}</td>
                                    </tr>
                                }
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Card.Body>
            {
                isPanelViewOpen &&
                <SidePanelView
                    inputParam_IsPanelOpen={isPanelViewOpen}
                    inputParam_SetterIsPanelOpen={setIsPanelViewOpen}
                    inputParam_PreviewBase64Document={previewBase64Document}
                />
            }
        </Card>
    );
};

export default DocumentTeach;